module.exports = __webpack_public_path__ + "a770b6797b68e3f8920e473eb824bac0.gif";